import { hyphenate } from '../utils/stringFormatter';
var msPattern = /^ms-/;
export default (function (string) {
  return hyphenate(string).replace(msPattern, '-ms-');
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-lib/es/style/hyphenateStyleName.js
// module id = 969
// module chunks = 35